import { memo } from 'react'
import { GeoJSON } from 'react-leaflet'

import { UseCreatePulverization } from '@/hooks/mutations/use-create-pulverization'

type WeedMapProps = Pick<NonNullable<UseCreatePulverization['data']>, 'layers'>

const PulverizationLayersComponent = ({ layers }: WeedMapProps) => {
  return (
    <>
      {layers.map((item) => (
        <GeoJSON
          key={JSON.stringify(item.composed_name_layers)}
          data={item.layer}
          style={{
            color: item.colorPalette,
            fillOpacity: 1,
            fill: true,
            weight: 1,
            fillRule: 'nonzero' as const,
          }}
        />
      ))}
    </>
  )
}

export const PulverizationLayers = memo(PulverizationLayersComponent)
